import { useState, useCallback } from 'react';

export const useTicketFilters = () => {
  const today = new Date();
  const defaultStart = toDateInput(new Date(today.getFullYear(), 0, 1));
  const defaultEnd = toDateInput(today);

  function toDateInput(d: Date) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  const [filters, setFilters] = useState({
    status: ['1','2','3','4','5','7'] as string[],
    module: [] as string[],
    priority: [] as string[],
    assigned_to: [] as string[],
    company: [] as string[],
    search: '',
    id_search: '',
    dateRangeCreated: {
      start: defaultStart,
      end: defaultEnd
    },
    dateRangeUpdated: {
      start: defaultStart,
      end: defaultEnd
    }
  });

  const updateFilter = useCallback((filterName: string, value: any) => {
    setFilters(prev => ({
      ...prev,
      [filterName]: value
    }));
  }, []);

  const updateDateRange = useCallback((type: 'created' | 'updated', range: 'start' | 'end', value: string) => {
    setFilters(prev => ({
      ...prev,
      [type === 'created' ? 'dateRangeCreated' : 'dateRangeUpdated']: {
        ...prev[type === 'created' ? 'dateRangeCreated' : 'dateRangeUpdated'],
        [range]: value
      }
    }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({
      status: [],
      module: [],
      priority: [],
      assigned_to: [],
      company: [],
      search: '',
      id_search: '',
      dateRangeCreated: {
        start: defaultStart,
        end: defaultEnd
      },
      dateRangeUpdated: {
        start: defaultStart,
        end: defaultEnd
      }
    });
  }, [defaultStart, defaultEnd]);

  const hasActiveFilters = useCallback(() => {
    return (
      filters.status.length > 0 ||
      filters.module.length > 0 ||
      filters.priority.length > 0 ||
      filters.assigned_to.length > 0 ||
      filters.company.length > 0 ||
      filters.search !== '' ||
      filters.id_search !== '' ||
      filters.dateRangeCreated.start !== defaultStart ||
      filters.dateRangeCreated.end !== defaultEnd ||
      filters.dateRangeUpdated.start !== defaultStart ||
      filters.dateRangeUpdated.end !== defaultEnd
    );
  }, [filters, defaultStart, defaultEnd]);

  return {
    filters,
    setFilters,
    updateFilter,
    updateDateRange,
    clearFilters,
    hasActiveFilters,
    defaultStart,
    defaultEnd,
  };
};